import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostBinding, Input, OnInit, Optional, Output, Self, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { noop } from 'rxjs';
export const PASSWORD_EDITOR_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => PasswordEditorComponent),
  multi: true,
};
@Component({
  selector: 'common-password-editor',
  templateUrl: './password-editor.component.html',
  styleUrls: ['./password-editor.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [PASSWORD_EDITOR_VALUE_ACCESSOR]
})
export class PasswordEditorComponent implements ControlValueAccessor {
  @HostBinding('class') class = 'input-group'
  @Input() label = '';
  @Input() value = '';
  @Input() disabled = false;
  @Input() type = 'password';
  @Input() pattern: string | RegExp;
  @Input() placeholder: string ;
  @Input() showTooltip = false;

  @Output() inputText = new EventEmitter();
  showText = false;
  constructor(private cdr: ChangeDetectorRef) {

  }


  writeValue(value: any): void {
    this.value = value;
    this.cdr.detectChanges();
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.cdr.detectChanges();
  }

  public onTouched: () => void = noop;
  public onChange: (_: any) => void = noop;

  onInput(text: string) {
    this.onTouched();
    this.onChange(text);
    this.inputText.emit(text);

    
  }
  toggleShowText(event: Event) {
    event.stopPropagation();
    this.showText = !this.showText;
    this.cdr.detectChanges();
  }
}
